export default {
  name: 'input_textarea',
  component_path: 'modules/procedures/blocks/BlockInputTextarea'
}